<!--  -->
<template>
  <div class="page">
    <div class="head">
      <div class="box">
        <div
          class="item"
          v-for="(item, index) in serveList"
          :key="index"
          @click="change(item, index)"
          :class="{ active: index === idx }"
          :id="`title-${index}`"
        >
          <img :src="item.img" alt="" />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <div class="content">
      <img  :src="tabIdx==1?info.major1Img:info.major2Img" alt="" />
    </div>
    <div class="foot" @click="openChat">
      <div>免费课程试听</div>
    </div>
  </div>
</template>

<script>
import serverInfo from './serverInfo';
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';

export default {
  components: {},
  data() {
    return {
       isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      serveList: serverInfo,
      idx: 0,
      tabIdx:0,
      info: {},
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    change(item, i) {
      this.idx = i;
      this.info = item;
    },
    openChat() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      const appUrl = 'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66e39b2a165a0b00012736b4' //app内弹窗链接
      const otherUrl = 'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=676686149bfdd90001515ccb' //h5和小程序
      const url = this.$root.$data.isApp ? appUrl : otherUrl
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const cookieToken = APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/oneToOneServeDetail' },
        });
      }
    },
  },
  created() {},
  mounted() {
    document.title = '特色服务';
    this.idx = Number(this.$route.query.index);
    this.info = this.serveList[this.idx];
    this.tabIdx=Number(this.$route.query.tabIdx);
    document.getElementById(`title-${this.idx}`).scrollIntoView({ behavior: 'smooth' });
     window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.page {
  padding: 205px 0 170px 0;
  background: #f7f8fc;
  .head {
    position: fixed;
    top: 0;
    left: 0;
    padding: 54px 0 36px 47px;
    background: #fff;
    .box {
      display: flex;
      width: 100%;
      overflow-x: auto;
      .item {
        flex-shrink: 0;
        padding-right: 47px;
        text-align: center;
        img {
          width: 72px;
          height: 72px;
        }
        p {
          padding-top: 11px;
          color: #333;
          font-weight: 400;
          font-size: 22px;
          text-align: center;
        }
      }
      .item.active {
        p {
          color: #ff7f41;
        }
      }
    }
  }
  .content {
    min-height: 71vh;
    margin-top: 22px;
    padding: 36px;
    background: #fff;
    img{
      width: 100%;
      border-radius: 18px;
    }
  }
  .foot {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    width: 750px;
    height: 167px;
    margin: 0 auto;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    box-shadow: 0 -4px 14px 0 rgba(0, 0, 0, 0.05);
    > div {
      width: 678px;
      height: 80px;
      margin: 22px auto 0;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
    }
  }
}
</style>
